import AuthGuard from '@/auth/main/route-guard/AuthGuard';
import Loadable from '@/common/presentation/components/utils/Loader/Loadable';
import React, { lazy } from 'react';
import { Outlet } from 'react-router';

type RouteConfig = {
  path: string;
  element: React.ReactElement;
  children?: RouteConfig[];
};

const createFeatureRoutes = (
  featureName: string,
  pages: { [key: string]: () => Promise<{ default: React.ComponentType }> },
  children: { path: string; pageKey: string }[]
): RouteConfig => {
  const resolvedChildren = children.map(({ path, pageKey }) => {
    const pageLoader = pages[pageKey];
    if (!pageLoader) {
      throw new Error(`Page loader for key "${pageKey}" is not defined.`);
    }
    const PageComponent = Loadable(lazy(pageLoader));
    return {
      path,
      element: <PageComponent />
    };
  });

  return {
    path: featureName,
    element: (
      <AuthGuard>
        <Outlet />
      </AuthGuard>
    ),
    children: resolvedChildren
  };
};

export default createFeatureRoutes;
